import {useCallback, useMemo} from 'react';

import {observer} from 'mobx-react-lite';

import type {Button} from '../../../../uikit/Button';
import type {GetComponentProps} from '../../../../utils/utility-types';
import type {Props} from './types';

import {RefundsListItemJSX} from '../../components/RefundsListItem';
import {RefundModel} from './model';

export const RefundsListItem = observer<Props>(
  ({onRetryButtonClick, payment, refund, ...rest}) => {
    const model = useMemo(
      () => new RefundModel(refund, payment),
      [refund, payment],
    );

    const onRetryButtonClickCb: GetComponentProps<typeof Button>['onClick'] =
      useCallback(
        e => {
          e.event.DOMEvent?.stopPropagation?.();

          onRetryButtonClick?.(e, refund);
        },
        [refund, onRetryButtonClick],
      );

    return (
      <RefundsListItemJSX
        amount={model.amountString}
        by={model.isRefundByStripe ? 'stripe' : 'card'}
        date={model.dateString}
        description={model.description}
        isRetryAvailable={model.isRetryAvailable}
        onRetryButtonClick={onRetryButtonClickCb}
        status={model.statusString}
        statusVariant={model.variant}
        tax={model.taxString}
        {...rest}
      />
    );
  },
);
